<template>
  <nav aria-label="Main Menu">
    <ul role="menu" aria-label="Navigation" class="header-navigation">
      <header-nav-item
        v-for="(item, index) in items"
        :route="item.routeName"
        :key="index"
        :exact="item.exact"
      >
        <font-awesome-icon :icon="item.icon" size="lg" pull="left" />
        <template v-slot:label>{{ item.label }}</template>
      </header-nav-item>
    </ul>
  </nav>
</template>

<script>
import HeaderNavItem from './HeaderNavItem';

export default {
  name: 'header-nav',
  components: { HeaderNavItem },
  data() {
    return {
      items: [
        // {
        //   label: 'Home',
        //   routeName: 'home',
        //   exact: true,
        //   icon: 'igloo',
        // },
        {
          label: 'Art Club',
          routeName: 'art-club',
          icon: 'graduation-cap',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.header-navigation {
  list-style: none;
  padding: 0;
  display: flex;
}
</style>
